
try {
    /*Loop Subscriptions URL Refresh Fix - This avoids the bug/error with reloading the loop subscriptions page with a fragment anchor link included in the URL*/
    let currentURL = window.location.href;
    if(currentURL && currentURL.endsWith("#dh-custom-bundle-start") && currentURL.includes("loop_subscriptions/bundle/62c0cabb773449408f9ab519012f2400")) {
        let cleanedURL = currentURL.replace("#dh-custom-bundle-start","");
        window.location.href = cleanedURL;
        // console.log("XR");
    } 
    else {
        /* Loop Subscriptions Page Scrollbar Fix */
        document.addEventListener('DOMContentLoaded', function () {
            if (window.location.pathname.startsWith('/a/loop_subscriptions/bundle/')) {
                document.body.classList.add('loop-sub-page');
            }
        });
    }

    /* 15% Off With Newsletter Sign Up Show/Hide Logic */
    document.addEventListener('DOMContentLoaded', function () {
        setTimeout(() => {
            let topBannerJoinLink = document.querySelector("a.announcement__content[href='#dd-footer-right']");
            if(topBannerJoinLink) {
                topBannerJoinLink.onclick = function(e) {
                    e.preventDefault();
                    window.omnisend = window.omnisend || [];
                    window.omnisend.push(['openForm', '67e9f5f6f8fbc713dd31685a']);
                } 
            }
        }, 100);
    });

    /*document.addEventListener('DOMContentLoaded', function () {
        setTimeout(() => {
            let newsSignUpPopupContainer = document.getElementById("app-embed-container-657254");
            if(newsSignUpPopupContainer) {
                newsSignUpPopupContainer.classList.add("dd-newsletter-sign-up-popup-container-hidden");
                let topBannerJoinLink = document.querySelector("a.announcement__content[href='#dd-footer-right']");
                if(topBannerJoinLink) {
                    topBannerJoinLink.onclick = function(e) {
                        e.preventDefault();
                        newsSignUpPopupContainer.classList.remove("dd-newsletter-sign-up-popup-container-hidden");
                    } 
                    console.log("z1");
                } else {
                    console.log("y3");
                }
            } else {
                console.log("x2");
            }
        }, 1000);
    });*/


    /* Gift Card Product Denominations 20% Off Label Update */
    document.addEventListener('DOMContentLoaded', function () {
        if (window.location.pathname.startsWith('/products/rocker-dog-food-gift-card')) {
            try {

                let prodInfoSection = document.querySelectorAll("product-info");
                if(prodInfoSection && prodInfoSection.length === 1) {
                    prodInfoSection[0].addEventListener('variant:change', (event) => {
                        updateVariantLabels();
                    }, true);
                    
                    //1st call is run automatically
                    updateVariantLabels();
                }

                function updateVariantLabels() {
                    try {
                        let prodVarContainer = document.querySelector(".variant-input-wrapper");
                        let denominationsValues = prodVarContainer.querySelectorAll("li");
                        let denominationsFieldLabel = prodVarContainer.querySelectorAll(".form__label");
                        let denomTitleSpan = denominationsFieldLabel[0].querySelector("span");

                        if(denominationsFieldLabel.length === 1 && denomTitleSpan
                        && denominationsFieldLabel[0].innerText.toLowerCase().includes("denominations:")) {

                            denominationsValues.forEach((denom) => {
                                let fInput = denom.querySelector("input");
                                let fLabel = denom.querySelector("label");


                                if(fInput && fLabel && denominationsFieldLabel[0]) {
                                    if(fLabel.innerText == "$120.00") {
                                        fLabel.innerHTML = "$100.00 <em>(+20% FREE)</em>";
                                        if(fInput.checked) {
                                            denomTitleSpan.innerHTML = "$120 Total Value"
                                        }
                                    }
                                    else if(fLabel.innerText == "$180.00") {
                                        fLabel.innerHTML = "$150.00 <em>(+20% FREE)</em>";
                                        if(fInput.checked) {
                                            denomTitleSpan.innerHTML = "$180 Total Value"
                                        }
                                    }
                                    else if(fLabel.innerText == "$240.00") {
                                        fLabel.innerHTML = "$200.00 <em>(+20% FREE)</em>";
                                        if(fInput.checked) {
                                            denomTitleSpan.innerHTML = "$240 Total Value"
                                        }
                                    }
                                }
                            });
                        }
                    } catch(ex) {
                        //No error display, just fail silently
                    }
                }
            } catch(e) {
                //No error display, just fail silently
            }
        }
    });

    
} catch(exc){}
